// import parseTime, formatTime and set to filter
//export { parseTime, formatTime } from '@/utils'

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
 function pluralize(time, label) {
    if (time === 1) {
      return time + label
    }
    return time + label + 's'
  }
  
  /**
   * @param {number} time
   */
  export function timeAgo(time) {
    const between = Date.now() / 1000 - Number(time)
    if (between < 3600) {
      return pluralize(~~(between / 60), ' minute')
    } else if (between < 86400) {
      return pluralize(~~(between / 3600), ' hour')
    } else {
      return pluralize(~~(between / 86400), ' day')
    }
  }
  
  /**
   * Number formatting
   * like 10000 => 10k
   * @param {number} num
   * @param {number} digits
   */
  export function numberFormatter(num, digits) {
    const si = [
      { value: 1E18, symbol: 'E' },
      { value: 1E15, symbol: 'P' },
      { value: 1E12, symbol: 'T' },
      { value: 1E9, symbol: 'G' },
      { value: 1E6, symbol: 'M' },
      { value: 1E3, symbol: 'k' }
    ]
    for (let i = 0; i < si.length; i++) {
      if (num >= si[i].value) {
        return (num / si[i].value).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
      }
    }
    return num.toString()
  }
  
  /**
   * 10000 => "10,000"
   * @param {number} num
   */
  export function toThousandFilter(num) {
    return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
  }
  
  /**
   * 10000000 => "10tr"
   * @param {number} num
   */
   export function toMillion(num) {
    let a = (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
    return a.substring(0, a.length - 8) + ' triệu';
  }
  
  export function toYesNo(num) {
    if(num)
      return 'Có'
    else 
      return 'Không'
  }
  
  /**
   * Upper case first char
   * @param {String} string
   */
  export function uppercaseFirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }
  
  // nếu sử dụng thư viện datejs
  // export function toDMY(str){
  //   if (!str) {
  //     return "";
  //   }
  //   return Date.parse(str).toString("dd/MM/yyyy");
  // }

  // ko sử dụng thư viện datejs, tối ưu load trang
  export function toDMY(str){
    if (!str) {
      return "";
    }

    var m = new Date(str);
    var dateString =
    ("0" + m.getUTCDate()).slice(-2) + "-" +
    ("0" + (m.getUTCMonth()+1)).slice(-2) + "-" +
    m.getUTCFullYear();
    return dateString;
  }
  
  // export function toDMYHM(str){
  //   if (!str) {
  //     return "";
  //   }
  //   return Date.parse(str).toString("dd/MM/yyyy HH:mm");
  // }

  export function toDMYHM(str){
    if (!str) {
      return "";
    }
    var m = new Date(str);
    var dateString =
    ("0" + m.getUTCDate()).slice(-2) + "-" +
    ("0" + (m.getUTCMonth()+1)).slice(-2) + "-" +
    m.getUTCFullYear() + " " +
    ("0" + (m.getUTCHours() + 7)).slice(-2) + ":" +
    ("0" + m.getUTCMinutes()).slice(-2);
    return dateString;
  }

  export function toYMDHMS(str){
    if (!str) {
      return "";
    }
    //var d = new Date(str).toLocaleString('en-US',{ timeZone: 'Asia/Bangkok' });
    var m = new Date(str);
    //console.log(m)
    var dateString =
    m.getUTCFullYear() + "-" +
    ("0" + (m.getUTCMonth()+1)).slice(-2) + "-" +
    ("0" + m.getUTCDate()).slice(-2) + " " +
    ("0" + (m.getUTCHours() + 7)).slice(-2) + ":" +
    ("0" + m.getUTCMinutes()).slice(-2) + ":" +
    ("0" + m.getUTCSeconds()).slice(-2);
    return dateString;
  }

  // export function toHMDMY(str){
  //   if (!str) {
  //     return "";
  //   }
  //   return Date.parse(str).toString("HH:mm dd/MM/yyyy");
  // }

  export function toHMDMY(str){
    if (!str) {
      return "";
    }
    var m = new Date(str);
    var dateString =
    ("0" + (m.getUTCHours() + 7)).slice(-2) + ":" +
    ("0" + m.getUTCMinutes()).slice(-2) + " " +
    ("0" + m.getUTCDate()).slice(-2) + "-" +
    ("0" + (m.getUTCMonth()+1)).slice(-2) + "-" +
    m.getUTCFullYear();
    return dateString;
  }

  export function toYMD(str){
    if (!str) {
      return "";
    }
    var m = new Date(str);
    console.log(m)
    var dateString =
    m.getUTCFullYear()+ "-" +
    ("0" + (m.getUTCMonth()+1)).slice(-2) + "-" +
    ("0" + m.getUTCDate()).slice(-2);
    return dateString;
  }

  export function toYMD2(str){
    if (!str) {
      return "";
    }

    var a = str.split('-');
    // var m = new Date(str);
    // console.log(m)
    // var dateString =
    // m.getUTCFullYear()+ "-" +
    // ("0" + (m.getUTCMonth()+1)).slice(-2) + "-" +
    // ("0" + m.getUTCDate()).slice(-2);
    return a[2] + '-' + a[1] + '-' + a[0];
  }
  
  export function getWeekendDate(){
    let now = new Date()
    let _7DayBefore = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() - 7
    )
    return _7DayBefore
  }
  
  export function getDateNow(){
    let now = new Date()
    let _7DayBefore = new Date(
        now.getDate()
    )
    return _7DayBefore
  }
  
  export function getDateAdd30(){
    var m = new Date(); // Now
    m.setDate(m.getDate() + 30); // Set now + 30 days as the new date

    var dateString =
    ("0" + m.getUTCDate()).slice(-2) + "/" +
    ("0" + (m.getUTCMonth()+1)).slice(-2) + "/" +
    m.getUTCFullYear();
    return dateString;
    return date;
    //console.log(date);
  }
  
  export function getDateSub3Month(){
    var date = new Date(); // Now
    date.setMonth(date.getMonth() - 3); // Set now -3 month as the new date
    return Date.parse(date).toString("yyyy-MM-dd");
    return date;
  }
  
  export function getDateAdd1Month(){
    var date = new Date(); // Now
    //console.log(date);
    //console.log(date.getMonth() + 1);
    date.setMonth(date.getMonth() + 1); // Set now + 1 month as the new date
    //console.log(date);
    return date;
    //console.log(date);
  }
  
  export function getMonthNow(){
    let now = new Date()
    let _7DayBefore = new Date(
        now.getMonth()
    )
    return _7DayBefore
  }
  
  export function getYearNow(){
    let now = new Date()
    let _7DayBefore = new Date(
        now.getFullYear()
    )
    return _7DayBefore
  }
  